<script>
  import { presetSchema } from "../manage/manageData.js";
  import { managePreSpec } from "../editor/storage.js";
  export let inputFocusAction, inputBlurAction;
  function loadPreset(name) {
    managePreSpec(name)
  }
</script>

<div id="example-loader">
  <div class="search-wrap">
    <select
      type="text"
      class="search"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:change={(e) => {
        loadPreset(e.target.value);
      }}
      alt="example loader"
    >
      <option
        value={undefined}>Load an example case</option
      >
      {#each presetSchema.presets as preset}
        <option value={preset.name}>{preset.title}</option>
      {/each}
    </select>
  </div>
</div>

<style>
  #example-loader {
    margin-top: -5px;
    margin-left: 0.5rem;
    width: 180px;
    min-width: 145px;
  }
  #example-loader .search-wrap {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    line-height: 100%;
    padding: 2px 0 2px 0;
    height: 33px;
  }
  .search-wrap select.search {
    width: 100%;
    height: 27px;
    padding: 0.2rem 0.5rem;
    margin: 0;
    border-radius: var(--default-radius);
    background-color: white;
    border: 1px solid #dddddd;
    font-size: 0.8rem;
    color: #454545;
  }
</style>
